export default {
  gql: {
    /* **********
     * DEPRECATED
     ********** */
    GET_DOCUMENTS: `
      query GetDocuments($ownerId: String) {
        getDocuments(ownerId: $ownerId) {
          id
          ownerId
          filename
          mimetype
          createdAt
        }
      }
    `,
    /* *************** */
    GET_DOCUMENT: `
      query GetDocument($id: String!) {
        getDocument(id: $id) {
          id
          ownerId
          name
          type
          filename
          mimetype
          createdAt
        }
      }
    `,
    GET_SHARED_DOCUMENTS: `
      query GetSharedDocuments(
        $ownerId: String
        $readerId: String
        $from: String
        $to: String
      ) {
        getSharedDocuments(
          ownerId: $ownerId
          readerId: $readerId
          from: $from
          to: $to
        ) {
          id
          ownerId
          name
          type
          filename
          mimetype
          createdAt
        }
      }
    `,
    GET_SHARED_DOCUMENT_PERIOD_FILTERS: `
      query GetSharedDocumentPeriodFilters(
        $ownerId: String
        $readerId: String
      ) {
        getSharedDocumentPeriodFilters(
          ownerId: $ownerId
          readerId: $readerId
        ) {
          label
          from
          to
        }
      }
    `,
    ADD_DOCUMENT: `
      mutation AddDocument(
        $file: Upload!
        $access: String
        $ownerId: String
        $readerId: String
      ) {
        addDocument(
          file: $file
          access: $access
          ownerId: $ownerId
          readerId: $readerId
        ) {
          id
          ownerId
          filename
          mimetype
          createdAt
        }
      }
    `,
    UPDATE_DOCUMENT: `
      mutation UpdateDocument(
        $id: String!
        $filename: String!
      ) {
        updateDocument(
          id: $id
          filename: $filename
        ) {
          id
          ownerId
          filename
          mimetype
          createdAt
        }
      }
    `,
    DELETE_DOCUMENT: `
      mutation DeleteDocument($id: String!) {
        deleteDocument(id: $id) {
          success
        }
      }
    `,
    GET_DOCUMENT_ACCEPTANCE: `
      query GetDocumentAcceptance(
        $accountId: String!
        $golfId: String!
      ) {
        getDocumentAcceptance(
          accountId: $accountId
          golfId: $golfId
        ) {
          id
          name
          acceptedAt
        }
      }
    `,
    VALIDATE_DOCUMENT: `
      mutation ValidateDocument($accountId: String!, $id: String!) {
        validateDocument(accountId: $accountId, id: $id) {
          success
        }
      }
    `,
  },
};
